import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import { authSlice } from './reducers/auth';
import { taskRunnerSlice } from './reducers/taskRunner';

export const store = configureStore({
  reducer: {
    taskRunnerSlice: taskRunnerSlice.reducer,
    authSlice: authSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;